var App = App || {};

App.ProductFinder = (function ($) {
    'use strict';

    function init() {

        $(".component-product-finder-ui").each(function () {

            var Component = $(this);
            var Goals = Component.find(".component-product-finder-goal button"),
                Products = Component.find(".component-product-finder-product"),
                Reset = Component.find(".component-product-finder-reset .reset");

            saveSelectedGoalsCookie(Component);

            Goals.click(function () {
                var selected = $(this).attr("aria-selected") == "true" ? "false" : "true";
                $(this).attr("aria-selected", selected)

                Products.removeClass("active");
                DisplayProducts(Component, Goals, Products, Reset);

                saveSelectedGoalsCookie(Component);
            });

            Reset.click(function () {
                Goals.attr("aria-selected", "false");
                Products.removeClass("active");
                DisplayProducts(Component);
                saveSelectedGoalsCookie(Component);
            });

        });

    }

    function DisplayProducts(Component) {

        var Products = Component.find(".component-product-finder-product");
        var ActiveProducts = GetActiveProducts(Component);

        if (ActiveProducts.length != 0) {
            StatusUpdate(Component, "Our list of products has been updated based on your financial goals.", false);
            Products.each(function () {
                if (ActiveProducts.indexOf(this.id) > -1) {
                    $(this).addClass("active");
                }
            });
        }
        else {
            StatusUpdate(Component, "No products match all of the provided filter criteria.", true);
        }
    }

    function GetActiveProducts(Component) {

        var Goals = Component.find(".component-product-finder-goal button[aria-selected='true']");
        var Products = Component.find(".component-product-finder-product");

        var ProductIdsArray = [];
        var ProductIdsFiltered = [];

        Goals.each(function () {
            $(this).attr("data-products").split(" ").forEach(function (ProductGoal) {
                ProductIdsArray.push(ProductGoal);
            })
        });

        Products.each(function () {

            // see how many times the product is referenced by selected goals
            var count = ProductIdsArray.filter(element => {
                return element === this.id;
            }).length;

            // if the product is referenced as many times as there are selected goals
            // we know the product is referenced by all selected goals and it qualifies to be returned
            if (count >= Goals.length) {
                ProductIdsFiltered.push(this.id);
            }
        });

        return ProductIdsFiltered;
    }

    function StatusUpdate(Component, message, visible) {
        var Status = Component.find(".component-product-finder-products-status");
        Status.text(message);

        if (visible) { Status.addClass("visible"); }
        else { Status.removeClass("visible"); }
    }

    function saveSelectedGoalsCookie(Component) {
        //allows GTM to grab active goals
        var selectedGoals = Component.find(".component-product-finder-goal button[aria-selected=true]"),
            selectedGoalTitles = [];
        selectedGoals.each(function () {
            selectedGoalTitles.push($(this).find(".text").text());
        });
        App.Cookies.setItem("SCFederalProductFinderGoals", selectedGoalTitles, 0, "/", window.location.hostname, window.location.protocol === "https:");
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.ProductFinder.init();
});